import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@styles/globals.css";
import { validateRequiredEnv } from "@config/env";
import { initSafeAreaEnvironment } from "@lib/platform/safe-area";
import { App } from "@/App";

validateRequiredEnv();
initSafeAreaEnvironment();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
